export const STATUS_OPTIONS = ["Completed", "In Progress", "Not Started"];

export const FILTER_TYPE_OPTIONS = [
    { value: "COURSE", label: "Course" },
    { value: "BUNDLE", label: "Curriculum" },
];

export const STATUS_FILTER_OPTIONS = [
    ...STATUS_OPTIONS.map((s) => ({ value: s, label: s })),
];
